<template>
<div class="header wwBackground">
    <settingsmenu :isOpen="openDropdown" @close="openDropdown = false" class="is-hidden-mobile is-hidden-tablet-only" />
    <div class="dropdownoverlay is-hidden-mobile is-hidden-tablet-only" v-if="openDropdown" @click="openDropdown=false"></div>
    <div class="columns is-mobile">

        <div class=" column is-4-desktop is-6-tablet is-6-mobile ">

        </div>
        <div class="wwTitle column is-4-desktop is-hidden-mobile is-hidden-tablet-only has-text-white  ">

            WireWizard Cloud

        </div>
        <div class="column is-2-desktop is-6-tablet is-6-mobile is-offset-2-desktop has-text-right" v-if="isLoggedIn">
            <div v-show="false" class="has-text-right">
                <div class="button is-large is-size-4" @click="logout()"><span class="">Logout</span></div>
            </div>

            <div  @click="openDropdown=!openDropdown" :class="{'is-active':openDropdown}" class="dropdown is-right">
                <div class="dropdown-trigger ">
                    <div class=" dropdownbutton has-text-white" aria-haspopup="true" aria-controls="dropdown-menu">
                        <span> <i class="fas fa-cog"></i></span>

                    </div>
                </div>
                <div v-if="false" class="dropdown-menu" id="dropdown-menu" role="menu">
                    <div class="dropdown-content">
                        <a href="#" v-if="isCompanyAdmin" class="dropdown-item" @click="openUserAdministration()">
                            Benutzer
                        </a>
                        <hr class="dropdown-divider">

                        <a class="dropdown-item" @click="logout()">
                            Ausloggen
                        </a>

                    </div>
                </div>
            </div>

        </div>
        <div class="column is-2-desktop is-6-tablet is-6-mobile is-offset-2-desktop has-text-right" v-else>
            <div class="button is-large" @click="goToLogin()">Login</div>
        </div>

    </div>

    <div class="mobileMenu is-hidden-desktop" @click="openDropdown = false" v-if="openDropdown">
        <div class="mobileMenuContainer">
            <div class="mobile-dropdownheader">Wirewizard</div>
            <a class="mobile-dropdownitem" @click="goToProjectPage()">
                Projekte
            </a>
            <a class="mobile-dropdownitem" @click="openUserAdministration()">
                Benutzer
            </a>
            <a class="mobile-dropdownitem" @click="logout()">
                Ausloggen
            </a>
        </div>
    </div>

</div>
</template>

<script>
import settingsmenu from '@/components/settingsmenu.vue'

export default {
    name: 'wwheader',
    props: [],
    components: {
        settingsmenu
    },
    mounted: function () {},
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            openDropdown: false
        }
    },
    methods: {
        logout() {
            this.$store.commit('setUsername', null)
            this.$store.commit('setUserRole', null)
            this.$store.commit('setUser', null)
            localStorage.bearertoken = null;
            this.$router.push({
                name: 'Login'
            })
        },
        goToLogin(){
                this.$router.push({
                name: 'Login'
            })
        }
        ,
        goToProjectPage() {
            this.$router.push({
                name: 'Projects'
            })

        },
        openUserAdministration() {
            this.$router.push({
                name: 'UserAdministration'
            })
        },

    },
    computed: {
        getUserName() {
            return this.$store.getters.getUsername;
        },
        isCompanyAdmin() {
            return this.$store.getters.getUserRole == 2;
        },
        isLoggedIn() {

            console.log("role"+this.$store.getters.getUserRole)
            console.log("role "+this.$store.getters.getUserRole != null && this.$store.getters.getUserRole != undefined && this.$store.getters.getUserRole >= 0)
            return this.$store.getters.getUserRole != null && this.$store.getters.getUserRole != undefined && this.$store.getters.getUserRole >= 0;
        }

    },
}
</script>

<style scoped>
.columns {
    margin: 0 !important
}

.dropdownbutton {
    font-size: 3em;
    cursor: pointer;
}

.header {
    margin-bottom: 2em;
}

.dropdown-item {
    font-size: 1.5em !important;
}

.dropdown-content {
    border: 2px solid rgba(1, 1, 1, 0.4);
    border-radius: 15px;
    background: #5CEBC7
}

.dropdownoverlay {
    position: absolute;
    width: 100vw;
    height: 100vh;
    top: 0;
    z-index: 20;
    left: 0;
    background: rgba(200, 200, 200, 0.7)
}

.dropdown-content a {
    padding: 0;
    margin: auto;
    text-align: center;
    display: block;
    font-weight: bolder;
}

.mobileMenu {
    position: absolute;
    height: 100vh;
    width: 100vw;
    z-index: 999;
    top: 0;
    left: 0;
    background: #5CEBC7
}

.mobile-dropdownheader {
    display: block;
    height: 18vh;
    font-size: 12vh;
    line-height: 18vh;
}

.mobile-dropdownitem {
    display: block;
    border-bottom: 1px solid rgba(200, 200, 200, 0.6);
    height: 15vh;
    font-size: 10vh;
    line-height: 15vh;
    background: #5CEBC7
}
</style>
